import { Dispatch } from "redux";
import axios from "axios";
import {
  LOADING_CART,
  ADD_CART,
  UPDATE_CART,
  DELETE_ITEM_CART,
  FETCH_CART,
  FETCH_CLIENT,
  CHECKOUT_CART,
  CartActionTypes,
  CheckoutData,
  FetchClientData,
  RESET_ALERT_MESSAGE_CART,
  FETCH_SHIPPING_COST,
  RESET_SHIPPING_COST,
  RESET_CLIENT,
} from "./types";
import { PUBLIC_URL } from "../serviceWorker";

export const fetchCart = () => async (dispatch: Dispatch<CartActionTypes>) => {
  dispatch({
    type: LOADING_CART,
  });
  await axios
    .get(PUBLIC_URL + "api/cart")
    .then((response: any) =>
      dispatch({
        type: FETCH_CART,
        payload: response.data,
      })
    )
    .catch((error: any) => console.log(error));
};

export const addProductCart =
  (request: any) => async (dispatch: Dispatch<CartActionTypes>) => {
    dispatch({
      type: LOADING_CART,
    });
    await axios
      .post(PUBLIC_URL + "api/cart", request)
      .then((response: any) =>
        dispatch({
          type: ADD_CART,
          payload: response.data,
        })
      )
      .catch((error: any) => console.log(error));
  };

export const updateProductCart =
  (request: any) => async (dispatch: Dispatch<CartActionTypes>) => {
    dispatch({
      type: LOADING_CART,
    });
    await axios
      .put(PUBLIC_URL + "api/cart/" + request.rowId, request)
      .then((response: any) =>
        dispatch({
          type: UPDATE_CART,
          payload: response.data,
        })
      )
      .catch((error: any) => console.log(error));
  };

export const deleteItemCart =
  (request: string) => async (dispatch: Dispatch<CartActionTypes>) => {
    dispatch({
      type: LOADING_CART,
    });
    await axios
      .delete(PUBLIC_URL + "api/cart/" + request)
      .then((response: any) =>
        dispatch({
          type: DELETE_ITEM_CART,
          payload: response.data,
        })
      )
      .catch((error: any) => {
        console.log(error);
        window.location.reload();
      });
  };

export const fetchClient =
  (request: FetchClientData) => async (dispatch: Dispatch<CartActionTypes>) => {
    dispatch({
      type: LOADING_CART,
    });
    await axios
      .get(
        `${PUBLIC_URL}api/cart/fetch_client/${request.cell_phone}${
          request.client_id ? "/" + request.client_id : ""
        }`
      )
      .then((response: any) =>
        dispatch({
          type: FETCH_CLIENT,
          payload: response.data,
        })
      )
      .catch((error: any) => console.log(error));
  };

export const fetchShippingCost =
  (province: number) => async (dispatch: Dispatch<CartActionTypes>) => {
    dispatch({
      type: LOADING_CART,
    });
    await axios
      .get(PUBLIC_URL + "api/cart/fetch_shipping_cost/" + province)
      .then((response: any) =>
        dispatch({
          type: FETCH_SHIPPING_COST,
          payload: response.data,
        })
      )
      .catch((error: any) => console.log(error));
  };

export const checkoutCart =
  (request: CheckoutData) => async (dispatch: Dispatch<CartActionTypes>) => {
    dispatch({
      type: LOADING_CART,
    });
    await axios
      .post(PUBLIC_URL + "api/cart/payment", request)
      .then((response: any) => {
        dispatch({
          type: CHECKOUT_CART,
          payload: response.data,
        });
        if (response.data.link === "/finished") {
          window.location.replace(response.data.link);
        } else {
          window.location.replace(response.data.link);
        }
      })
      .catch((error: any) => console.log(error));
  };

export const extendCartSession =
  () => async (dispatch: Dispatch<CartActionTypes>) => {
    dispatch({
      type: LOADING_CART,
    });
    await axios
      .get(PUBLIC_URL + "api/cart/extendCartSession")
      .then((response: any) =>
        dispatch({
          type: FETCH_CART,
          payload: response.data,
        })
      )
      .catch((error: any) => console.log(error));
  };

export const resetAlertMessage =
  () => async (dispatch: Dispatch<CartActionTypes>) => {
    dispatch({
      type: RESET_ALERT_MESSAGE_CART,
    });
  };

export const resetShippingCost =
  () => async (dispatch: Dispatch<CartActionTypes>) => {
    dispatch({
      type: RESET_SHIPPING_COST,
    });
  };

export const resetClient =
  () => async (dispatch: Dispatch<CartActionTypes>) => {
    dispatch({
      type: RESET_CLIENT,
    });
  };
